const DAY_MS = 86400000;

function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

function formatHeading(target) {
    const now = new Date();
    const today = startOfDay(now);
    const targetDay = startOfDay(target);
    const diffDays = Math.round((today - targetDay) / DAY_MS);
    if (diffDays === 0) return 'HÔM NAY';
    if (diffDays === 1) return 'HÔM QUA';
    if (diffDays < 7) return `${diffDays} NGÀY TRƯỚC`;
    return target.toLocaleDateString('vi-VN').toUpperCase();
}

export default function groupByDate(items, pickDate = (i) => i.snapshot_at) {
    const buckets = new Map();
    for (const item of items || []) {
        const iso = pickDate(item);
        if (!iso) continue;
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) continue;
        const key = startOfDay(d);
        if (!buckets.has(key)) buckets.set(key, { key, heading: formatHeading(d), items: [] });
        buckets.get(key).items.push(item);
    }
    return [...buckets.values()].sort((a, b) => b.key - a.key);
}
